// Copyright 2025. WebPros International GmbH. All rights reserved.

import { Translate } from '@plesk/ui-library';
import { Dialog } from 'common/components/Dialog/Dialog';
import { IComputeResourceRecoveryReadinessStatusResponse } from 'common/api/resources/DisasterRecovery';
import ErrorMessage from 'admin/disasterRecovery/components/ErrorMessage/ErrorMessage';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    compatibilityDetails: IComputeResourceRecoveryReadinessStatusResponse['destination_compute_resources'][number]['compatibility_details'] | null;
}

export default function SourceTypesConflictDialog({
    isOpen,
    onClose,
    compatibilityDetails,
}: IProps) {
    return (
        <Dialog
            heading={<Translate content="disasterRecovery.readinessStatus.destinationComputeResources.table.sourceType" />}
            closeHandler={onClose}
            isOpen={isOpen}
            size={'sm'}
        >
            {!compatibilityDetails?.sources_is_compatible && (
                <ErrorMessage>
                    <Translate content="disasterRecovery.readinessStatus.destinationComputeResources.dialogs.sourceTypes.differentSources" />
                </ErrorMessage>
            )}

            {!compatibilityDetails?.products_is_compatible && (
                <ErrorMessage>
                    <Translate content="disasterRecovery.readinessStatus.destinationComputeResources.dialogs.sourceTypes.differentProducts" />
                </ErrorMessage>
            )}
        </Dialog>
    );
}